/**
 * page : 이용안내
 */
import { useEffect } from "react";
import { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Editor } from "@tinymce/tinymce-react";
import Parser from 'html-react-parser';
import * as zy from '../common/zeroyear-1.0.0';
import '../assets/js/nav.js';
let sessionStorage = window.sessionStorage;

export default function GuidePage () {
    const [admin, setAdmin] = useState(false);
    // 인사말 Content01 Edit용, 조회용 변수 2개 선언
    const [contentEdit, setContentEdit] = useState('');
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    /**
     * close modal
     */
    const closeModal = () => {
        setContentEdit(content);
        setShowModal(false);
    };
    /**
     * open modal
     */
    const openModal = () => { setShowModal(true); };
    const selectAll = () => {
        zy.select('selectGuide', ['1'],(item) => {
            setContent(item[0].GUIDE_CONTENT);
            setContentEdit(item[0].GUIDE_CONTENT);
        });
    };
    /**
     * content change hanlder
     */
    const setContentEditChange = (data) => {
        setContentEdit(data||'');
    };
    const btnContentSave = () => {
        zy.modify('updateGuide', [contentEdit, '1'],(item) => {
            selectAll();
            closeModal();
        });
    };
    useEffect(() => {
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    }, []);
    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">회사소개</a></li>
                        <li>이용안내</li>
                    </ol>
                    <h2>이용안내</h2>
                </div>
            </section>
            <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="col-lg-8">
                        {admin ? <button className="btn-cancel" onClick={openModal}>수정</button> : null}
                        <div className="portfolio-info">
                            {Parser(content)}
                        </div>
                    </div>
                </div>
            </section>
            <Modal 
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                centered
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>수정</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Editor
                        apiKey={'g473ctmydd0wpefxozp61yzmmfhdzfkv7o2m6czhrwe9b1ct'}
                        value={contentEdit}
                        id='tinyMce_editor'
                        init={{
                            height: 600,
                            menubar: false,
                            plugins: [
                                'lists',
                                'link',
                                'image',
                                'charmap',
                                'preview',
                                'searchreplace',
                                'fullscreen',
                                'media',
                                'table',
                                'code',
                                'help',
                                'emoticons',
                                'codesample',
                                'quickbars',
                            ],
                            toolbar:
                                'undo redo | blocks | ' +
                                'lists table link charmap searchreplace | ' +
                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                'bold italic forecolor | alignleft aligncenter ' +
                                'image media codesample emoticons fullscreen preview | ' +
                                'removeformat | help ',
                        }}
                        onEditorChange={setContentEditChange}
                    />
                    <Modal.Footer>
                        <button className="btn-cancel" onClick={closeModal}>닫기</button>
                        <button className="btn-normal" onClick={btnContentSave}>등록완료</button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>
        </main>
        </>
    );
}
